import React from "react";
import {ff, form, FormActions, localUTCToDate} from "@mc/mc-legacy";
import {FormErrors, reduxForm} from "redux-form";
import {connect} from "react-redux";
import {Button, CardBody, Card, Label} from "reactstrap";
import "./KontaktyNotifikaceForm.scss";
import {i18n} from "../../i18n/i18n";
import {withLang} from "../../i18n/withLang";

const FormBody = form.FormBody;

const validate = (formData: FormData, props) => {
    const errors: FormErrors<FormData> = {};

    if (!formData.jmeno) {
        errors.jmeno = i18n(props.lang, "Validation_fieldRequired");
    }
    if (!formData.prijmeni) {
        errors.prijmeni = i18n(props.lang, "Validation_fieldRequired");
    }
    if (!formData.datumNarozeni) {
        errors.datumNarozeni = i18n(props.lang, "Validation_fieldRequired");
    } else {
        // Pokud je dítěti 18+, tak validační hláška, že musí být mladší 18 let
        const datumNarozeni = localUTCToDate(formData.datumNarozeni);
        const dnes = new Date();
        const dnes18 = new Date(dnes.getFullYear() - 18, dnes.getMonth(), dnes.getDate());
        if (+datumNarozeni <= +dnes18) {
            errors.datumNarozeni = i18n(props.lang, "SubjektForm_IsChildValidation");
        } else if (+datumNarozeni > +dnes) {
            errors.datumNarozeni = i18n(props.lang, "SubjektForm_datumNarozeniMinulost");
        }
    }
    if (!formData.adresa) {
        errors.adresa = i18n(props.lang, "Validation_fieldRequired");
    }

    return errors;
};


class AddChildForm extends React.Component<any, {}> {
    static formName = "addChildForm";

    constructor(props) {
        super(props);
    }

    render() {
        const {submitting, handleSubmit, onClose} = this.props;

        return (
            <form.Form className={"edit-dialog-form"} onSubmit={handleSubmit}>
                <FormBody>
                    <h2 className={"mt-3 mb-3"}>{i18n(this.props.lang, "ProfilePage_pristupy_AddChild")}</h2>
                    <Card className="mb-3">
                        <CardBody>
                            <div className={"mb-3"}>
                                <Label for={"newPassword"}>{i18n(this.props.lang, "SubjektForm_jmeno")}</Label>
                                <ff.String
                                    label={false}
                                    name={"jmeno"}
                                    required
                                    disabled={submitting}
                                />
                            </div>
                            <div className={"mb-3"}>
                                <Label for={"newPassword"}>{i18n(this.props.lang, "SubjektForm_prijmeni")}</Label>
                                <ff.String
                                    label={false}
                                    name={"prijmeni"}
                                    required
                                    disabled={submitting}
                                />
                            </div>
                            <div className={"mb-3"}>
                                <Label for={"newPassword"}>{i18n(this.props.lang, "SubjektForm_datumNarozeni")}</Label>
                                <ff.SimpleDate
                                    label={false}
                                    name={"datumNarozeni"}
                                    required
                                    disabled={submitting}
                                />
                            </div>
                            <div className={"mb-3"}>
                                <Label for={"newPassword"}>{i18n(this.props.lang, "SubjektForm_adresa")}</Label>
                                <div className={"adresa-input-container"}>
                                    <ff.Adresa
                                        placeholder={i18n(this.props.lang, "SubjektForm_adresaSearch")}
                                        label={false}
                                        name={"adresa"}
                                        required
                                        disabled={submitting}
                                    />
                                </div>
                            </div>
                        </CardBody>
                    </Card>

                </FormBody>
                <FormActions submitButton={false} cancelButton={false}>
                    <Button className={"pl-3 pr-3"} color="primary" outline onClick={onClose}>{i18n(this.props.lang, "button_cancel")}</Button>
                    <Button
                        className={"ml-2"}
                        color={"primary"}
                        type={"submit"}
                        disabled={submitting}
                    >
                        {i18n(this.props.lang, "ProfilePage_pristupyAddPristup")}
                    </Button>
                </FormActions>

            </form.Form>
        );
    }
}

function mapStateToProps(state, props) {
    const formName = props.form || AddChildForm.formName;
    // const selector = formValueSelector(formName);
    return {
        // kontakt: selector(state, name),
    };
}

const reduxFormObj = reduxForm<any, any>({
    form: AddChildForm.formName,
    validate
})(AddChildForm);
export default withLang(connect(mapStateToProps)(reduxFormObj));
